import { Icons } from "assets";
import classNames from "classnames";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SideCanvas from "shared/components/home/sideCanvas";
import { routeConstant } from "shared/routes/routeConstant";
import CustomButton from "../customButton";
import styles from "./style.module.scss";

const Header = () => {
  const [openSideBar, setOpenSideBar] = useState<boolean>(false);
  const navigate = useNavigate();
  return (
    <>
      <SideCanvas isOpen={openSideBar} setIsOpen={setOpenSideBar} />
      <nav className={classNames(styles.navContainer)}>
        <div
          className={classNames(styles.customContainer, styles.headerContainer)}
        >
          <div className="flex gap-2 flex-1">
            <Icons.Hamburger
              onClick={() => {
                setOpenSideBar(true);
              }}
              className={classNames(styles.hamIcon, "sm:hidden cursor-pointer")}
            />
            <Link to={routeConstant.home.path}>
              <Icons.Logo />
            </Link>
          </div>
          <div className="hidden flex-1 flex-row items-center justify-center gap-4 sm:flex">
            <a
              href={routeConstant.aboutUS.path}
              rel="noreferrer"
              target="_blank"
            >
              About Us
            </a>
            <a
              href={routeConstant.contactUs.path}
              rel="noreferrer"
              target="_blank"
            >
              Contact Us
            </a>
          </div>
          <div className="flex-1 flex justify-end">
            <CustomButton
              title="Login"
              containerStyle={classNames(styles.loginBtn)}
              onClick={() => {
                navigate(routeConstant.login.path);
              }}
            />
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
